import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'

import { useAppContext } from '@/hooks'

interface UnavailableItemsModalProps {
	onClose: () => void
	onConfirm: () => void
	open: boolean
	unavailableItems: any[]
}

export const UnavailableItemsModal = ({
	onConfirm,
	open,
	onClose,
	unavailableItems,
}: UnavailableItemsModalProps) => {
	const { t } = useAppContext()

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="unavailable-items-dialog-title"
		>
			<DialogTitle id="unavailable-items-dialog-title">
				Some selected items are no longer available
			</DialogTitle>
			<DialogContent dividers>
				<DialogContentText sx={{ mb: 2 }}>
					{t('UNAVAILABLE_ITEMS_DIALOG_DESCRIPTION')}
				</DialogContentText>
				{unavailableItems.length > 0 ? (
					<List>
						{unavailableItems.map((item) => (
							<ListItem key={item.uuid} disableGutters>
								<ListItemIcon>
									<ErrorOutlineIcon color="warning" />
								</ListItemIcon>
								<ListItemText
									primary={
										<Typography
											sx={{
												textDecoration: 'line-through',
												fontStyle: 'italic',
												color: 'text.secondary',
											}}
										>
											{item.name || item.code}
										</Typography>
									}
								/>
							</ListItem>
						))}
					</List>
				) : (
					<DialogContentText>No unavailable items found.</DialogContentText>
				)}
			</DialogContent>
			<DialogActions>
				<Button
					onClick={onConfirm}
					autoFocus
					variant="contained"
					color="warning"
					disabled={unavailableItems.length === 0}
				>
					Remove {unavailableItems.length} Item
					{unavailableItems.length !== 1 ? 's' : ''}
				</Button>
				<Button onClick={onClose} color="primary">
					{t('CANCEL')}
				</Button>
			</DialogActions>
		</Dialog>
	)
}
